// Уведомления Windows на этом устройстве: включить и проверить (T-047, №10 2026-09-30).
//
// Одно место на окно настроек и на плашку над печатью: разрешение Windows спрашивается
// одинаково, и вторая копия этой логики разошлась бы с первой на первом же исправлении.

import { t } from '@/shared/i18n';
import {
  requestSystemNotificationPermission,
  showSystemNotification,
} from '@/shared/lib/systemNotification';

import { setNotifyEnabled } from './model/deviceMarks';

/** Включить галочку устройства. `false` — Windows не разрешила уведомления Рестомаркеру. */
export async function turnOnDeviceNotifications(): Promise<boolean> {
  if ((await requestSystemNotificationPermission()) !== 'granted') return false;
  await setNotifyEnabled(true);
  return true;
}

/**
 * Пробное уведомление — сразу, без сервера. Отвечает на вопрос «Windows вообще
 * пропускает наши уведомления?» отдельно от «пришло ли предупреждение в ленту»: владелец
 * ждал уведомления, а сервер по тестовой этикетке ничего не создал (2026-09-30), и по
 * экрану этого было не отличить от молчащего Windows.
 */
export async function showTestNotification(): Promise<boolean> {
  if ((await requestSystemNotificationPermission()) !== 'granted') return false;
  showSystemNotification({
    title: t('alerts.device.testTitle'),
    body: t('alerts.device.testBody'),
    tag: 'restomarker-test',
  });
  return true;
}
